import React from 'react';
import { useTheme, Box, BoxProps } from '@material-ui/core';

export const MessagingGirlSVG = ({ ...props }: BoxProps) => {
    const theme = useTheme();

    const fillColor = theme.palette.primary.main;

    return (
        <Box {...props}>
            <svg
                xmlns="http://www.w3.org/2000/svg"
                xmlnsXlink="http://www.w3.org/1999/xlink"
                width="100%"
                height="100%"
                viewBox="0 0 825.85001 506.44001"
                role="img"
                data-artist="Katerina Limpitsouni"
                data-source="https://undraw.co/"
            >
                <path
                    d="m438.22,378.66001c-1.76999,10.70999-11.09,18.91-22.29001,18.91s-20.53-8.20001-22.29001-18.91h-57.04001v123.61002h158.66v-123.60999h-57.04001l.00003-.00003Z"
                    fill="#d9d9d9"
                    stroke-width="0"
                />
                <rect
                    x="339.36"
                    y="501.81"
                    width="15.68001"
                    height="2.76999"
                    fill="#b6b3c5"
                    stroke-width="0"
                />
                <rect
                    x="478.19"
                    y="502.26999"
                    width="15.67999"
                    height="2.76999"
                    fill="#b6b3c5"
                    stroke-width="0"
                />
                <path
                    d="m735.01001,381.89002H96.85c-4.88,0-8.85-3.97-8.85-8.85001V8.85c0-4.88,3.97-8.85,8.85-8.85h638.15995c4.88,0,8.84998,3.97,8.84998,8.85v364.20002c0,4.88-3.96997,8.85001-8.84998,8.85001h0l.00006-.01001Z"
                    fill="#2f2e41"
                    stroke-width="0"
                />
                <rect
                    x="104.14"
                    y="15.68"
                    width="624.49001"
                    height="352.36999"
                    fill="#fff"
                    stroke-width="0"
                />
                <path
                    d="m0,505.53c0,.5.39999.91.91.91h824.03c.5,0,.91-.39999.91-.91s-.39999-.91-.91-.91H.91c-.5,0-.91.39999-.91.91Z"
                    fill="#2f2e43"
                    stroke-width="0"
                />
                <rect
                    x="452.85547"
                    y="162.80304"
                    width="171"
                    height="15.50007"
                    rx="7.75002"
                    ry="7.75002"
                    fill={fillColor}
                    stroke-width="0"
                />
                <rect
                    x="486.35547"
                    y="225.80304"
                    width="137.5"
                    height="15.50007"
                    rx="7.75002"
                    ry="7.75002"
                    fill={fillColor}
                    stroke-width="0"
                />
                <rect
                    x="585.35547"
                    y="266.80303"
                    width="38.5"
                    height="15.50007"
                    rx="7.75002"
                    ry="7.75002"
                    fill={fillColor}
                    stroke-width="0"
                />
                <rect
                    x="252.85547"
                    y="205.80299"
                    width="131.5"
                    height="15.50007"
                    rx="7.75002"
                    ry="7.75002"
                    fill="#cacacb"
                    stroke-width="0"
                />
                <rect
                    x="252.85547"
                    y="245.80298"
                    width="49.5"
                    height="15.50007"
                    rx="7.75003"
                    ry="7.75003"
                    fill="#cacacb"
                    stroke-width="0"
                />
                <rect
                    x="497.35547"
                    y="184.80299"
                    width="126.5"
                    height="15.50007"
                    rx="7.75002"
                    ry="7.75002"
                    fill={fillColor}
                    stroke-width="0"
                />
                <line
                    x1="243.85547"
                    y1="110.80311"
                    x2="632.85547"
                    y2="110.80311"
                    fill="none"
                    stroke="#000"
                    stroke-miterlimit="10"
                    stroke-width="2"
                />
                <line
                    x1="256.35547"
                    y1="97.30311"
                    x2="341.62376"
                    y2="97.30311"
                    fill="none"
                    stroke="#000"
                    stroke-miterlimit="10"
                    stroke-width="2"
                />
                <polygon
                    points="133.90734 266.95399 127.08699 293.90612 174.18238 293.32469 168.79281 268.69826 133.90734 266.95399"
                    fill="#ec9c9f"
                    stroke-width="0"
                />
                <polygon
                    points="125.19564 359.03605 114.9706 403.77063 96.15131 493.33475 104.87267 495.07903 164.8177 361.59231 125.19564 359.03605"
                    fill="#ec9c9f"
                    stroke-width="0"
                />
                <polygon
                    points="144.88194 369.22618 163.76862 411.04756 191.50494 495.07903 203.13343 492.17191 177.9956 347.31894 144.88194 369.22618"
                    fill="#ec9c9f"
                    stroke-width="0"
                />
                <path
                    d="m129.73176,282.80932s-21.0265,37.02558-17.19211,77.92577c0,0,30.99861,23.4725,80.79675,1.74427l-20.49905-81.80038-43.10559,2.13034Z"
                    fill="#090814"
                    stroke-width="0"
                />
                <path
                    d="m94.6951,504.01361c-1.00113-.8206-1.54155-1.73691-1.60613-2.72359-.07391-1.12857.4838-2.33945,1.65737-3.59899.02817-.36244.39241-4.8529,1.20407-5.657-.06804-.24037-.48147-1.83392.19625-2.86866.31927-.48742.83388-.77152,1.52958-.84442l.03031-.00313.01502.02682c.01962.03507,1.99467,3.50875,4.96562,3.81373,1.7033.17484,3.40864-.71249,5.0687-2.63806.05967-.14226.52872-2.4876.83146-4.04004l.01211-.06207,16.18785,8.61544,9.46241,2.65115c1.18928.33323,2.01988,1.43857,2.01988,2.68802,0,1.06539-.61278,2.05207-1.56112,2.51364l-4.58661,2.2324c-1.9165.93281-4.05348,1.42585-6.17995,1.42585h-24.87937c-1.61191,0-3.16297-.54373-4.36745-1.53106Z"
                    fill="#090814"
                    stroke-width="0"
                />
                <path
                    d="m187.14161,504.01361c-1.00113-.8206-1.54155-1.73691-1.60613-2.72359-.07391-1.12857.4838-2.33945,1.65737-3.59899.02817-.36244.39241-4.8529,1.20407-5.657-.06804-.24037-.48147-1.83392.19625-2.86866.31927-.48742.83388-.77152,1.52958-.84442l.03031-.00313.01502.02682c.01962.03507,1.99467,3.50875,4.96562,3.81373,1.7033.17484,3.40864-.71249,5.0687-2.63806.05967-.14226.52872-2.4876.83146-4.04004l.01211-.06207,16.18785,8.61544,9.46241,2.65115c1.18928.33323,2.01988,1.43857,2.01988,2.68802,0,1.06539-.61278,2.05207-1.56112,2.51364l-4.58661,2.2324c-1.9165.93281-4.05348,1.42585-6.17995,1.42585h-24.87937c-1.61191,0-3.16297-.54373-4.36745-1.53106Z"
                    fill="#090814"
                    stroke-width="0"
                />
                <path
                    d="m140.67445,183.31593c0-10.49112,8.50475-18.99588,18.99588-18.99588,10.49119,0,18.99595,8.50475,18.99595,18.99588,0,8.50837-5.59422,15.70925-13.30477,18.12757l-3.67223,24.26908-18.72057-15.60045s4.04421-5.15134,6.21305-10.95977c-5.12608-3.40182-8.50731-9.22316-8.50731-15.83644Z"
                    fill="#ec9c9f"
                    stroke-width="0"
                />
                <path
                    d="m141.18623,202.06797l22.37376,14.30207,10.32709,18.23765c2.99019,5.28068,4.00009,11.45432,2.84839,17.41254l-4.74482,24.54687h-49.47121s7.81675-51.21249,7.81675-51.21249c.99768-6.53645,3.48735-12.75532,7.27598-18.17443l3.57406-5.11221Z"
                    fill={fillColor}
                    stroke-width="0"
                />
                <path
                    d="m134.57531,208.27449s.88705,6.72999,9.10548,6.94977q16.67112.44582,16.67112.44582s-14.09285-34.29671-8.29807-30.43294c5.79478,3.86377,21.24752-12.33435,21.24752-12.33435l4.55958,8.55144s10.89316-3.94464-1.17929-13.60407c0,0-14.40418-11.13618-29.69595-4.44888s-12.41039,44.87321-12.41039,44.87321Z"
                    fill="#090814"
                    stroke-width="0"
                />
                <rect
                    x="70.35547"
                    y="343.30311"
                    width="167"
                    height="37"
                    fill="#cacacb"
                    stroke-width="0"
                />
                <circle
                    cx="90.40085"
                    cy="361.18262"
                    r="11"
                    fill="none"
                    stroke="#000"
                    stroke-miterlimit="10"
                    stroke-width="2"
                />
                <line
                    x1="105.40085"
                    y1="352.18262"
                    x2="170.67007"
                    y2="352.18262"
                    fill="none"
                    stroke="#000"
                    stroke-miterlimit="10"
                    stroke-width="2"
                />
                <line
                    x1="105.40085"
                    y1="361.18262"
                    x2="219.27449"
                    y2="361.18262"
                    fill="none"
                    stroke="#000"
                    stroke-miterlimit="10"
                    stroke-width="2"
                />
                <line
                    x1="105.40085"
                    y1="368.49799"
                    x2="228.99537"
                    y2="368.49799"
                    fill="none"
                    stroke="#000"
                    stroke-miterlimit="10"
                    stroke-width="2"
                />
                <path
                    d="m145.01414,330.14192l-.39938-18.40908,10.74845-.23318.39938,18.40908c2.00539,1.86164,3.32919,4.75425,3.40034,8.03381.12449,5.73837-3.62437,10.47369-8.37335,10.57671-4.74898.10303-8.69968-4.46525-8.82417-10.20362-.07115-3.27955,1.12605-6.22686,3.04873-8.17371Z"
                    fill="#ec9c9f"
                    stroke-width="0"
                />
                <polyline
                    points="159.85302 238.00363 159.85302 327.23411 141.18623 327.23411 135.66941 238.75686"
                    fill={fillColor}
                    stroke-width="0"
                />
            </svg>
        </Box>
    );
};
